import {store as AppStore} from '../store/store';
import {fetchMe} from '../store/slices/me_slice';

export async function meLoader(store: typeof AppStore) {
    const token = store.getState().exchangeToken.token;
    if (token) {
        const result = await store.dispatch(fetchMe({token}));

        return result;
    }
    return null;
}
